export const SET_SELECTED_MERCHANT = "SET_SELECTED_MERCHANT";
export const TOGGLE_FETCHING_MERCHANTS = "TOGGLE_FETCHING_MERCHANTS";
export const TOGGLE_FETCHING_MERCHANTS_DOCUMENTS =
  "TOGGLE_FETCHING_MERCHANTS_DOCUMENTS";
export const SET_MERCHANTS = "SET_MERCHANTS";
export const SET_MERCHANTS_DOCUMENTS = "SET_MERCHANTS_DOCUMENTS";
export const APPROVE_MERCHANT = "APPROVE_MERCHANT";
